/**
 * Asynchronously loads the component for CampaignPage
 */

import { lazyLoad } from 'utils/loadable';

export const CampaignPage = lazyLoad(
  () => import('./index'),
  module => module.CampaignPage,
);
